import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "absolute inset-x2 z-1" }
const _hoisted_2 = {
  key: 0,
  class: "flex -ml-x2"
}

import ProductSplashLabelNewArrival from '@/shared/product/splash/ui/ProductSplashLabelNewArrival.vue';
import SplashLabel from '@/shared/content/blocks/helpers/SplashLabel.vue';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import { ProductLabelType } from '@/types/productServerApi';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VisualizationHighlights',
  setup(__props) {

const { productData } = useProductDetailData();
const newArrivalLabel = computed(() => productData.value.productLabels?.find((label) => label.type === ProductLabelType.NewArrival));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProductSplashLabelNewArrival, {
      label: _unref(newArrivalLabel),
      class: "mb-3 -ml-x2"
    }, null, 8, ["label"]),
    (_unref(productData).productSpotLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SplashLabel, {
            label: _unref(productData).productSpotLabel.text,
            "background-color": _unref(productData).productSpotLabel.hexColorCode
          }, null, 8, ["label", "background-color"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})